export function setUrlPathParams(url: string, ...ids: (string | number)[]): string {
  return ids.reduce((newUrl: string, id) => newUrl.replace(/:id/, id.toString()), url);
}
